module.exports = __webpack_public_path__ + "img/sidebar_selected_water_meter.0970b15d.svg";